import { inject } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { ActivatedRouteSnapshot, ResolveFn, Routes } from '@angular/router';
import { Observable, of } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import {
  PrescriptionTxReqRx, IPrescriptionTxReqRx
} from 'app/shared/model/prescription-tx-req-rx.model';
import PrescriptionTxReqRxService from './prescription-tx-req-rx.service';
import PrescriptionTxReqRxComponent from './prescription-tx-req-rx.component';
import ResolvePagingParams from '../resolve-paging-params.service';

export const PrescriptionTxReqRxResolve: ResolveFn<IPrescriptionTxReqRx> = (route: ActivatedRouteSnapshot): Observable<IPrescriptionTxReqRx> => {
  const { id } = route.params;
  if (id) {
    return inject(PrescriptionTxReqRxService).find(id).pipe(
      filter((response: HttpResponse<PrescriptionTxReqRx>) => response.ok),
      map((prescriptionTxReq: HttpResponse<PrescriptionTxReqRx>) => prescriptionTxReq.body)
    );
  }
  return of(new PrescriptionTxReqRx());
};

export const prescriptionTxReqRoute: Routes = [
  {
    path: '',
    component: PrescriptionTxReqRxComponent,
    resolve: {
      pagingParams: ResolvePagingParams
    },
    data: {
      authorities: ['ROLE_USER'],
      defaultSort: 'id,asc',
      pageTitle: 'bjcrxApp.prescriptionTxReq.home.title'
    }
  }
];
